export default __webpack_public_path__ + "static/media/blue_two.32620cfc.jpg";